<template>
    <div class="blocks-section" v-if="colors.length > 0">
        <span class="blocks-label">{{ $tc('common.blocks', 2) }}:</span>
        <div v-for="(color, i) in colors" :key="i" class="block-chip">
            <span class="block-chip-dot" :style="{ backgroundColor: color }" />
            {{ `${$tc('common.blocks', 1)} ${i + 1}` }}
        </div>
        <slot />
    </div>
</template>

<script>
export default {
    name: "BlockFooter",
    props: {
        colors: {
            type: Array,
            default: () => []
        },
    },
}
</script>

<style scoped>
.blocks-section {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    height: 44px;
    padding: 0 16px;
    border-top: 1px solid var(--v-outline-base);
    box-shadow: 0 -6px 20px rgba(0, 0, 0, 0.12);
    background: var(--v-surface-base);
    z-index: 2;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.blocks-section::-webkit-scrollbar {
    display: none;
}

.blocks-label {
    font-size: 11px;
    font-weight: 500;
    color: var(--v-txtMuted-base);
    white-space: nowrap;
    flex-shrink: 0;
}

.block-chip {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
    flex-shrink: 0;
    background: var(--v-surface2-base);
    border: 1px solid var(--v-outline2-base);
    color: var(--v-txtSecondary-base);
}

.block-chip-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
}
</style>
